// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_gs-0";
export var fulfillmentPanelBody = "_gs-1";